import { render, staticRenderFns } from "./SubcategoriaConfig.vue?vue&type=template&id=45f58f9e"
import script from "./SubcategoriaConfig.vue?vue&type=script&lang=js"
export * from "./SubcategoriaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports